<template>
  <v-select
    :items="options"
    :label="label"
    :v-model="model"
  />
</template>

<script>
export default {
  name: 'GenericSelector',
  props: {
    model: {
      type: String,
      default: 'N/A',
      required: false,
    },
    label: {
      type: String,
      default: 'N/A',
      required: false,
    },
    options: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style scoped>

</style>
